export const SalesServiceImplFactory = ({
  salesRepository,
}: {
  salesRepository: ISalesRepository;
}): ISalesService => {
  const addSalesAckService: IAddSalesAckService = async (payload) => {
    try {
      const response = await salesRepository.addSalesAckAPI(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return {
    addSalesAckService,
  };
};
